module.exports = __webpack_public_path__ + "img/BecomeIns-4.b632cc50.svg";